<template>
    <div class="main">
        <van-tabs v-model="active" animated sticky color="#FEB013" title-active-color="#FEB013" @click="changeTabs">
            <van-tab>
                <template #title>我是乘客 <van-tag round color="#FEB013">{{Pcount}}</van-tag></template>
                <van-radio-group
                    v-model="Pradio"
                    direction="horizontal"
                    checked-color="#FEB013"
                    icon-size="16px"
                    @change="changeRadio"
                    style="margin: 8px 12px 0 12px;font-size: 14px;">
                    <van-radio name="1">晚班拼车</van-radio>
                    <van-radio name="2">早班拼车</van-radio>
                </van-radio-group>
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                    <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                        style="height:100vh;"
                    >
                        <div v-for="item in passengerList" :key="item._id" class="Cellgroup" @click="detailData(item)">
                            <div class="route-box" style="justify-content: space-between;margin-bottom:8px;">
                                <div style="font-weight: 600;">{{item.DateTime}} {{item.DepartTime}}</div>
                                <div>
                                    <a style="color:#FEB013;">{{item.Status}}</a>
                                    <van-icon name="arrow" color="#999999"/>
                                </div>
                            </div>
                            <div class="route-box">
                                <div class="route-icon" v-if="Pradio === '1'">路线{{item.Route}}</div>
                                <div class="route-text">{{item.Origin}}</div>
                                <div style="color: #999999;padding:0 8px;">------</div>
                                <div class="route-text">{{item.Destination}}</div>
                            </div>
                            <div style="font-size: 12px;margin-top:8px;">途径地点：{{ item.Way }}</div>
                        </div>

                    </van-list>
                </van-pull-refresh>
                
            </van-tab>
            <van-tab>
                <template #title>我是司机 <van-tag round color="#FEB013">{{Dcount}}</van-tag></template>
                <van-radio-group
                    v-model="Dradio"
                    direction="horizontal"
                    checked-color="#FEB013"
                    icon-size="16px"
                    @change="changeRadio"
                    style="margin: 8px 12px 0 12px;font-size: 14px;">
                    <van-radio name="1">晚班拼车</van-radio>
                    <van-radio name="2">早班拼车</van-radio>
                </van-radio-group>
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                    <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                    >
                        <div v-for="item in driverList" :key="item._id" class="Cellgroup" @click="detailData(item)">
                            <div class="route-box" style="justify-content: space-between;margin-bottom:8px;">
                                <div style="font-weight: 600;">{{item.DateTime}} {{item.DepartTime}}</div>
                                <div>
                                    <a style="color:#FEB013;">{{item.Status}}</a>
                                    <van-icon name="arrow" color="#999999"/>
                                </div>
                            </div>
                            <div class="route-box">
                                <div class="route-icon" v-if="Dradio === '1'">路线{{item.Route}}</div>
                                <div class="route-text">{{item.Origin}}</div>
                                <div style="color: #999999;padding:0 8px;">------</div>
                                <div class="route-text">{{item.Destination}}</div>
                            </div>
                            <div style="font-size: 12px;margin-top:8px;">途径地点：{{ item.Way }}</div>
                        </div>

                    </van-list>
                </van-pull-refresh>
                <div style="height: 50px;" />
            </van-tab>
        </van-tabs>
    </div>
</template>
<script>
export default {
    data() {
        return {
            active: 0,
            Pnum: 0,
            Pcount: 0,
            passengerList: [],
            Dnum: 0,
            Dcount: 0,
            driverList: [],
            loading: false,
            finished: false,
            refreshing: false,
            Pradio: '1',
            Dradio: '1'
        }
    },
    mounted() {
        // const test = {"errno":0,"data":{"errcode":0,"errmsg":"ok","userid":"2017551","name":"吴昌悦","department":[2267],"position":"软件开发工程师","mobile":"15812615614","gender":"1","email":"wuchangyue@jianlianmed.com","avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/0","status":1,"isleader":0,"extattr":{"attrs":[{"name":"英文名","value":"","type":0,"text":{"value":""}},{"name":"工号","value":"2017551","type":0,"text":{"value":"2017551"}},{"name":"身份证","value":"","type":0,"text":{"value":""}}]},"english_name":"","telephone":"020-88985632","enable":1,"hide_mobile":0,"order":[0],"external_profile":{"external_attr":[],"external_corp_name":""},"main_department":2267,"qr_code":"https://open.work.weixin.qq.com/wwopen/userQRCode?vcode=vc5b6c10860443246c","alias":"","is_leader_in_dept":[0],"address":"","thumb_avatar":"http://wework.qpic.cn/wwhead/duc2TvpEgSTPk74IwG7Bs6QbDoJ0d3L4YVkyYficZxxcflGOZ1LUI81OkNwXIicNlbdduibhLKxSGc/100","direct_leader":[],"openid":"ozAQBt9Jauj5fMYuM9Q0bNmhaAo8","access_token":"hER4OJaZReJSc_9Mi6NCJTXyliK2QkEDuj0ruK4CsiFGKySTq81qK6AsR7GqX6bROcq28TctrjQqtXheO0mKenvkX6pu6kkuP9cSO51qDnBHwnOThgl4thnSeAFw_PlA0aUdAX3tE5yPHs3IIgOwB4bEc6yFKchMe7tjjaACla90dBlIe8j8JuSB-SOLpoWVXMI36ulQW7uRs6VXRfH57w"}}
        // this.WXInfo = test.data
        this.WXInfo = JSON.parse(localStorage.getItem('userinfo')).data
        this.active = localStorage.getItem('Role') === 'driver' ? 1 : 0
    },
    methods: {
        async getPassengerList() {
            let select = {
                UserId: this.WXInfo.userid,
                skip: this.Pnum,
                limit: 10
            }
            let result = []
            if (this.Pradio === '1') {
                result = await this.getPassengerData(select)
            } else {
                result = await this.getWorkTravelFromPassenger(select)
            }
            if (result.success && result.data.length) {
                this.Pcount = result.count
                this.Pnum +=  10
            } else {
                this.finished = true
            }
            return result.data
        },
        async getDriverList() {
            let select = {
                UserId: this.WXInfo.userid,
                skip: this.Dnum,
                limit: 10
            }
            let result = []
            if (this.Dradio === '1') {
                result = await this.getAllRouteList(select)
            } else {
                result = await this.getWorkTravel(select)
            }
            if (result.success && result.data) {
                this.Dcount = result.count
                this.Dnum += 10
            } else {
                this.finished = true
            }
            return result.data
        },
        detailData(item) {
            if (this.active === 0) {
                if (this.Pradio === '1') {
                    this.$router.push('/detail?id=' + item.ParentsId + '&role=passenger' )
                } else {
                    this.$router.push('/work/detail?id=' + item.ParentsId + '&role=passenger' )
                }
            } else {
                if (this.Dradio === '1') {
                    this.$router.push('/detail?id=' + item._id + '&role=driver' )
                } else {
                    this.$router.push('/work/detail?id=' + item._id + '&role=driver' )
                }
            }
        },
        async onLoad() {
            if (this.active === 0) {
                // 异步更新数据
                setTimeout(async() => {
                    if (this.refreshing) {
                        this.Pnum = 0
                        this.passengerList = await this.getPassengerList()
                        this.refreshing = false
                    } else {
                        if (!this.Pnum) {
                            this.passengerList = await this.getPassengerList()
                        } else {
                            const result = await this.getPassengerList()
                            this.passengerList = [...this.passengerList, ...result]
                        }
                    }
                    this.loading = false
                    if (this.passengerList.length >= this.Pcount) {
                        this.finished = true
                    }
                }, 100)
            } else {
                // 异步更新数据
                setTimeout(async() => {
                    if (this.refreshing) {
                        this.Dnum = 0
                        this.driverList = await this.getDriverList()
                        this.refreshing = false
                    } else {
                        if (!this.Dnum) {
                            this.driverList = await this.getDriverList()
                        } else {
                            const result = await this.getDriverList()
                            this.driverList = [...this.driverList, ...result]
                        }
                    }
                    this.loading = false
                    if (this.driverList.length >= this.Dcount) {
                        this.finished = true
                    }
                }, 100)
            }
        },
        onRefresh() {
            // 清空列表数据
            this.finished = false
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true
            this.onLoad()
        },
        changeRadio() {
            this.Dnum = 0
            this.Pnum = 0
            // 清空列表数据
            this.finished = false
            // 重新加载数据
            // 将 loading 设置为 true，表示处于加载状态
            this.loading = true
            this.onLoad()
        },
        changeTabs() {
            this.Dnum = 0
            this.Pnum = 0
            // 开启刷新数据
            this.finished = false
        },
        // API
        // 查询用户数据
        getUserInfoData() {
            return this.$request({
                url: this.$api.getUserInfo,
                method: 'GET',
                params: {
                    // OpenId: this.WXInfo.openid
                    UserId: this.WXInfo.userid
                }
            })
        },
        getPassengerData(data) {
            return this.$request({
                url: this.$api.getPassengerList,
                method: 'GET',
                params: data
            })
        },
        getAllRouteList(data) {
            return this.$request({
                url: this.$api.getAllRouteList,
                method: 'GET',
                params: data
            })
        },
        // 获取早班司机数据
        getWorkTravel(data) {
            return this.$request({
                url: this.$api.getWorkTravel,
                method: 'GET',
                params: data
            })
        },
        // 获取早班乘客数据
        getWorkTravelFromPassenger(data) {
            return this.$request({
                url: this.$api.getWorkTravelFromPassenger,
                method: 'GET',
                params: data
            })
        },
    }
}
</script>
<style>
    #app {
        height:auto;
        min-height:100vh;
    }
</style>
<style lang="less" scoped>
    .Cellgroup {
        margin: 8px 12px;
        background-color: #ffffff;
        border-radius: 4px;
        padding: 10px 16px;
        line-height: 1.5;
    }
    .route-icon {
        border:1px solid #999999;
        color:#999999;
        border-radius:4px;
        padding: 1px 4px;
        font-size: 14px;
        margin-right: 8px;
    }
    .route-text {
        font-size: 15px;
        font-weight: 600;
    }
    .route-box {
        display:flex;
        align-items: center;
    }
</style>
